import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { COLOR_PRIMARY_1 } from 'src/colors';

const UnavailableIcon = () => {
  return (
    <Tooltip title="Unavailable due to data anomalies">
      <WarningAmberIcon sx={{ color: COLOR_PRIMARY_1 }} />
    </Tooltip>
  );
};

export default UnavailableIcon;
